import React from 'react';
import { Form } from "../../../collections/Form";
import { Paragraph } from "../../../typography/Paragraph";
import { Link } from "../../../elements/Link";
export var getFormMarkup = function getFormMarkup(buttonText, linkText, linkUrl, onAccept, text) {
  return React.createElement(Form, {
    onSubmit: onAccept,
    submitButtonText: buttonText
  }, React.createElement(Paragraph, null, text), React.createElement(Link, {
    href: linkUrl,
    willOpenInNewTab: true
  }, linkText));
};